import './style.css';

import {
  AccessibleContent,
  SideNavBarItem,
  Menu,
  Flex,
  Text, View,
  IconArrowDoubleStartLine,
  IconArrowStartLine,
  Badge,
  SideNavBar,
  Icon,
  IconPeerReviewLine,
  IconPlusLine,
  IconToggleStartLine,
  IconCalendarMonthLine,
  IconConfigureLine,
  IconSettingsLine,
  IconClockLine,
  IconBulletListCircleOutlineLine,
  IconReplyLine,
  IconSearchLine,
  IconRemoveLinkLine,
  Popover,
  SVGIcon
} from '@smarterservices/smarter-ui';
import useAppStore from '../../stores/app';
import useSessionStore from '../../stores/session';
import useDataBroker from '../../stores/dataBroker';
import { useEffect, useState, useMemo } from 'react';
import AwaitingCheckin from '../Checkin/waiting';
import InReview from '../Checkin/active';
import Reconnect from '../Checkin/reconnect';
import SentBack from '../Checkin/SentBack';
import RecentlyExited from '../Checkin/RecentlyExited';

const RoomNavBar = () => {
  const openDrawer = useAppStore((state) => state.openDrawer);
  const magnificationEnabled = useAppStore((state) => state.magnification.enabled);
  const toggleMagnification = useAppStore((state) => state.toggleMagnification);
  const focusedSessionSid = useSessionStore((state) => state.focusedSessionSid);

  const waiting = useSessionStore((state) => state.waiting);
  const review = useSessionStore((state) => state.review);
  const testing = useSessionStore((state) => state.testing);
  const reconnect = useSessionStore((state) => state.reconnect);
  const sentback = useSessionStore((state) => state.sentback);
  const checkout = useSessionStore((state) => state.checkout);
  const addRandom = useSessionStore((state) => state.addRandom);

  const popoverOffsetY = -22;


  const mode = useDataBroker((state) => state.mode);

  const [checkinCount, setCheckinCount] = useState(0);
  const [showWaitingPopover, setShowWaitingPopover] = useState(false);
  const [showInReviewPopover, setShowInReviewPopover] = useState(false);
  const [showReconnectPopover, setShowReconnectPopover] = useState(false);
  const [showSentBackPopover, setShowSentBackPopover] = useState(false);
  const [showRecentlyExitedPopover, setShowRecentlyExitedPopover] = useState(false);

  useEffect(() => {
    setCheckinCount(Object.keys(waiting)?.length + Object.keys(reconnect)?.length);
  }, [waiting, reconnect]);

  const renderWaitingIcon = useMemo(() => {
    if (Object.keys(waiting)?.length) {
      return (
        <Badge
          count={Object.keys(waiting)?.length}
          variant="danger"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent
                alt={`${formattedCount} sessions awaiting.`}
              >
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          <IconClockLine />
        </Badge>
      );
    } else {
      return <IconClockLine />;
    }
  }, [waiting]);

  const renderReconnectIcon = useMemo(() => {
    if (Object.keys(reconnect)?.length) {
      return (
        <Badge
          count={Object.keys(reconnect)?.length}
          variant="danger"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent
                alt={`${formattedCount} sessions awaiting from reconnection.`}
              >
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          <IconRemoveLinkLine />
        </Badge>
      );
    } else {
      return <IconRemoveLinkLine />;
    }
  }, [reconnect]);

  const IconUserCheck = (props) => (
    <SVGIcon
      {...props}
      name="IconUserCheck"
      viewBox="0 0 1920 1920"
    >
      {/* 1920 / 24 = 80 */}
      <g transform="scale(90)">
        <path
          fill="currentColor"
          d="M17.55 11.289L14.712 8.45l.713-.688l2.125 2.125l4.25-4.25l.708.713zM9 11.385q-1.237 0-2.119-.882T6 8.385t.881-2.12T9 5.386t2.119.88t.881 2.12t-.881 2.118T9 11.385m-7 7.23V16.97q0-.619.36-1.158q.361-.54.97-.838q1.416-.679 2.834-1.018q1.417-.34 2.836-.34t2.837.34t2.832 1.018q.61.298.97.838q.361.539.361 1.158v1.646zm1-1h12v-.646q0-.332-.215-.625q-.214-.292-.593-.494q-1.234-.598-2.545-.916T9 14.616t-2.646.318t-2.546.916q-.38.202-.593.494Q3 16.637 3 16.97zm6-7.23q.825 0 1.413-.588T11 8.384t-.587-1.412T9 6.384t-1.412.588T7 8.384t.588 1.413T9 10.384m0-2"
        />
      </g>
    </SVGIcon>
  )

  const IconPlaylistAddCheckCircle = (props) => (
    <SVGIcon
      size="small"
      {...props}
      name="IconPlaylistAddCheckCircle"
      viewBox="0 0 1920 1920"
    >
      {/* 1920 / 24 = 80 */}
      <g transform="scale(90)">
        <path
          fill="currentColor"
          d="m14.05 16.242l-1.065-1.046q-.146-.146-.347-.158t-.367.153t-.165.356q0 .192.165.357l1.213 1.213q.243.243.566.243t.566-.243l3.344-3.363q.146-.146.153-.344q.006-.198-.16-.368q-.164-.155-.353-.158t-.354.162zM8 14.5h1q.213 0 .356-.144t.144-.357t-.144-.356T9 13.5H8q-.213 0-.356.144t-.144.357t.144.356T8 14.5m0-3h5q.213 0 .356-.144t.144-.357t-.144-.356T13 10.5H8q-.213 0-.356.144t-.144.357t.144.356T8 11.5m0-3h5q.213 0 .356-.144t.144-.357t-.144-.356T13 7.5H8q-.213 0-.356.144t-.144.357t.144.356T8 8.5M12.003 21q-1.866 0-3.51-.708q-1.643-.709-2.859-1.924t-1.925-2.856T3 12.003t.709-3.51Q4.417 6.85 5.63 5.634t2.857-1.925T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.708 3.51t-1.924 2.859t-2.856 1.925t-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"
        />
      </g>
    </SVGIcon>
  )

  const renderInReviewIcon = useMemo(() => {
    if (Object.keys(review)?.length) {
      return (
        <Badge
          count={Object.keys(review)?.length}
          variant="primary"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent
                alt={`${formattedCount} sessions active in checkin.`}
              >
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          { /* IconPersonCheckOutline */}
          <IconUserCheck />
        </Badge>
      );
    } else {
      return (
        <>
          { /* IconPersonCheckOutline */}
          <IconUserCheck size="small" />
        </>
      );
    }
  }, [review]);

  const renderSentBackIcon = useMemo(() => {
    if (Object.keys(sentback)?.length) {
      return (
        <Badge
          count={Object.keys(sentback)?.length}
          variant="primary"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent
                alt={`${formattedCount} sessions awaiting checkin.`}
              >
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          <IconReplyLine />
        </Badge>
      );
    } else {
      return <IconReplyLine />;
    }
  }, [sentback]);

  const renderRecentlyExitedIcon = useMemo(() => {
    if (Object.keys(checkout)?.length) {
      return (
        <Badge
          count={Object.keys(checkout)?.length}
          variant="primary"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent
                alt={`${formattedCount} sessions awaiting checkout.`}
              >
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          <IconPlaylistAddCheckCircle />
        </Badge>
      );
    } else {
      return <IconPlaylistAddCheckCircle />;
    }
  }, [checkout]);

  const renderQueueIcon = () => {
    return <IconBulletListCircleOutlineLine />;
    if (checkinCount) {
      return (
        <Badge
          count={checkinCount}
          variant="danger"
          formatOutput={function (formattedCount) {
            return (
              <AccessibleContent
                alt={`${formattedCount} sessions awaiting checkin.`}
              >
                {formattedCount}
              </AccessibleContent>
            );
          }}
        >
          <IconBulletListCircleOutlineLine />
        </Badge>
      );
    } else {
      return <IconBulletListCircleOutlineLine />;
    }
  };

  const renderOptionsIcon = () => {
    return <IconConfigureLine />;
  };

  const renderGetNextIcon = () => {
    return <Icon name="IconGradebookImportLine" size="small" />;
  };

  const getNavItems = useMemo(() => {
    const navItems = [
      //(Object.keys(waiting)?.length + Object.keys(reconnect)?.length) && (
      <SideNavBarItem
        key="Nav_Next"
        label="Get Next"
        icon={renderGetNextIcon()}
        onClick={() => useSessionStore.getState().openNextCheckinSession()}
        themeOverride={{
          contentPadding: '1.1em 0',
        }}
      />
      //)
      ,
      <Popover
        key="Nav_Waiting_Popover"
        offsetY={popoverOffsetY}
        renderTrigger={
          <SideNavBarItem
            key="Nav_Waiting"
            label="Waiting"
            icon={renderWaitingIcon}
            themeOverride={{
              contentPadding: '1.1em 0',
            }}
          />
        }
        isShowingContent={showWaitingPopover}
        onShowContent={() => setShowWaitingPopover(true)}
        onHideContent={() => setShowWaitingPopover(false)}
        on="click"
        placement="start top"
        shouldContainFocus
        shouldReturnFocus
      >
        <View as="div" padding="xxx-small" width="300px">
          <AwaitingCheckin onMenuDismiss={() => setShowWaitingPopover(false)} />
        </View>
      </Popover>,
      <Popover
        key="Nav_InReview_Popover"
        offsetY={popoverOffsetY}
        renderTrigger={
          <SideNavBarItem
            key="Nav_Checkin"
            label="Check In"
            icon={renderInReviewIcon}
            themeOverride={{
              contentPadding: '1.1em 0',
            }}
          />
        }
        isShowingContent={showInReviewPopover}
        onShowContent={() => setShowInReviewPopover(true)}
        onHideContent={() => setShowInReviewPopover(false)}
        on="click"
        placement="start top"
        shouldContainFocus
        shouldReturnFocus
      >
        <View as="div" padding="xxx-small" width="300px">
          <InReview onMenuDismiss={() => setShowInReviewPopover(false)} />
        </View>
      </Popover>,
      <Popover
        key="Nav_Reconnect_Popover"
        offsetY={popoverOffsetY}
        renderTrigger={
          <SideNavBarItem
            key="Nav_Reconnect"
            label="Reconnect"
            icon={renderReconnectIcon}
            themeOverride={{
              contentPadding: '1.1em 0',
            }}
          />
        }
        isShowingContent={showReconnectPopover}
        onShowContent={() => setShowReconnectPopover(true)}
        onHideContent={() => setShowReconnectPopover(false)}
        on="click"
        placement="start top"
        shouldContainFocus
        shouldReturnFocus
      >
        <View as="div" padding="xxx-small" width="300px">
          <Reconnect onMenuDismiss={() => setShowReconnectPopover(false)} />
        </View>
      </Popover>,
      <Popover
        key="Nav_SentBack_Popover"
        offsetY={popoverOffsetY}
        renderTrigger={
          <SideNavBarItem
            key="Nav_SentBack"
            label="Sent Back"
            icon={renderSentBackIcon}
            themeOverride={{
              contentPadding: '1.1em 0',
            }}
          />
        }
        isShowingContent={showSentBackPopover}
        onShowContent={() => setShowSentBackPopover(true)}
        onHideContent={() => setShowSentBackPopover(false)}
        on="click"
        placement="start top"
        shouldContainFocus
        shouldReturnFocus
      >
        <View as="div" padding="xxx-small" width="300px">
          <SentBack />
        </View>
      </Popover>,
      <Popover
        key="Nav_RecentlyExited_Popover"
        offsetY={popoverOffsetY}
        renderTrigger={
          <SideNavBarItem
            key="Nav_RecentlyExited"
            label="Recently Ended"
            icon={renderRecentlyExitedIcon}
            themeOverride={{
              contentPadding: '1.1em 0',
            }}
          />
        }
        isShowingContent={showRecentlyExitedPopover}
        onShowContent={() => setShowRecentlyExitedPopover(true)}
        onHideContent={() => setShowRecentlyExitedPopover(false)}
        on="click"
        placement="start top"
        shouldContainFocus
        shouldReturnFocus
      >
        <View as="div" padding="xxx-small" width="300px">
          <RecentlyExited onMenuDismiss={() => setShowRecentlyExitedPopover(false)} />
        </View>
      </Popover>,

      (Object.keys(testing)?.length > 0 || focusedSessionSid) && (
        <div key="Nav_Magnify_Wrapper" className="nav-magnify">
          <SideNavBarItem
            key="Nav_Magnify"
            icon={magnificationEnabled ? <Icon name="IconZoomOutAreaFilled" size="xx-small" /> : <Icon name="IconZoomInArea" size="xx-small" />}
            label={magnificationEnabled ? 'Magnify: Off' : 'Magnify'}
            onClick={() => toggleMagnification()}
            themeOverride={{
              contentPadding: '1.1em 0',
            }}
          />
        </div>
      ),

      <div key="Nav_Queue_Wrapper" className="nav-queue">
        <SideNavBarItem
          key="Nav_Queue"
          label="Queue"
          icon={renderQueueIcon()}
          onClick={() => openDrawer('checkin')}
          themeOverride={{
            contentPadding: '1.1em 0',
          }}
        />
      </div>
      ,



      mode === 'local' && (
        <SideNavBarItem
          key="Nav_Add"
          icon={<IconPlusLine />}
          label="Add"
          onClick={() => addRandom()}
          themeOverride={{
            contentPadding: '1.1em 0',
          }}
        />
      ),
    ].filter(Boolean);

    return navItems;
  }, [waiting, reconnect, review, sentback, checkout, testing, focusedSessionSid, magnificationEnabled, mode, renderWaitingIcon, renderReconnectIcon, renderInReviewIcon, renderSentBackIcon, renderRecentlyExitedIcon, showWaitingPopover, showInReviewPopover, showReconnectPopover, showSentBackPopover, showRecentlyExitedPopover, openDrawer, toggleMagnification, addRandom]);

  return (
    <>
      <SideNavBar
        key="side-bar-nav"
        id="side-bar-nav"
        label="Proctor Room Navigation"
        style={{ flexDirection: 'column', display: 'flex' }}
        defaultMinimized={false}
        toggleLabel={{
          expandedLabel: 'Collapse Navigation',
          minimizedLabel: 'Expand Navigation',
        }}
      >
        {getNavItems}
      </SideNavBar>
    </>
  );
};

export default RoomNavBar;

/*

  <Menu
          key="Nav_Exit_Menu"
          placement="end"
          shouldContainFocus
          shouldReturnFocus
          mountNode={() => document.body} // Ensures the menu overlays everything
          trigger={
            <SideNavBarItem
              className="nav-exit"
              key="Nav_Exit"
              style={{ marginTop: 'auto' }}
              icon={<IconArrowDoubleStartLine />}
              label="Exit"
              themeOverride={{
                contentPadding: '1.1em 0',
                marginTop: 'auto',
              }}
            />
          }
        >
          <Menu.Item onSelect={() => exitRoom()}>
            <Flex alignItems="center">
              <Flex.Item margin="0 xx-small 0 0">
                <IconToggleStartLine size="x-small" />
              </Flex.Item>
              <Flex.Item>
                <Text>Switch Rooms</Text>
              </Flex.Item>
            </Flex>
          </Menu.Item>
          <Menu.Separator />
          <Menu.Item onSelect={() => logout()}>
            <Flex alignItems="center">
              <Flex.Item margin="0 xx-small 0 0">
                <IconArrowStartLine size="x-small" />
              </Flex.Item>
              <Text>Log Out</Text>
            </Flex>
          </Menu.Item>
        </Menu>

*/
